import Parse from 'parse';

import { Injectable } from '@angular/core';

import {
  SampleTopology,
  ObjectTopology,
  ProtocolPipelineTopology,
  MethodTypeTopology,
} from '@telespot/infrastructure/parse';

import { MethodType } from '../state';
import { type MethodTypeRepository } from '@telespot/protocols/domain';

@Injectable({
  providedIn: 'root',
})
export class TelespotMethodTypeService implements MethodTypeRepository {
  public async findForSample(sampleId: string): Promise<MethodType> {
    const sampleQuery = new Parse.Query(SampleTopology.TABLE).equalTo(ObjectTopology.ID, sampleId);

    const protocolPipelinesQuery = new Parse.Query(ProtocolPipelineTopology.TABLE)
      .matchesKeyInQuery(ProtocolPipelineTopology.METHOD_TYPE, SampleTopology.METHOD_TYPE, sampleQuery)
      .include([ProtocolPipelineTopology.PIPELINE]);

    const labelConfigsQuery = new Parse.Query('LabelConfig').matchesKeyInQuery(
      'methodType',
      SampleTopology.METHOD_TYPE,
      sampleQuery
    );

    const protocolPipelines = await protocolPipelinesQuery.find();
    const labelConfigs = await labelConfigsQuery.find();

    if (!protocolPipelines.length) return undefined;

    const parseMethodType = protocolPipelines[0].get(ProtocolPipelineTopology.METHOD_TYPE);

    const methodType: MethodType = {
      id: parseMethodType.id,
      pipelineIds: protocolPipelines.reduce(
        (acc, protoPipeline) => ({
          ...acc,
          [protoPipeline.get(ProtocolPipelineTopology.PIPELINE)?.id]: {
            configId: protoPipeline.id,
            pipeline: protoPipeline.get(ProtocolPipelineTopology.PIPELINE)?.id,
          },
        }),
        {}
      ),
      labelConfig: labelConfigs.reduce(
        (acc, labelConfig) => ({
          ...acc,
          [labelConfig.get('label')]: {
            configId: labelConfig.id,
            label: labelConfig.get('label'),
            color: labelConfig.get('color'),
          },
        }),
        {}
      ),
      acquisitionFields: parseMethodType.get(MethodTypeTopology.ASSET_DATA_FIELDS),
    };

    return methodType;
  }
}
